import ContentsTypes from "@dafrontcms/core/lib/cms/shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import DocaposteSectionPreview from "../components/DocaposteSection/DocaposteSectionPreview";
export const DocaposteSection = {
    label: "Section docaposte",
    type: ContentsCustomTypes.DOCAPOSTE_SECTION,
    Preview: DocaposteSectionPreview,
    icon: "window",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Surtitre",
            key: "surtitle",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Alignement de titre",
            key: "justify",
            type: ContentsTypes.SELECT,
            options: [
                { label: "À gauche", value: "flex-start" },
                { label: "À droite", value: "flex-end" },
            ],
            value: "flex-start",
        },
        {
            label: "Fond",
            key: "background",
            type: ContentsTypes.RADIO_GROUP,
            options: [
                { label: "Aucun", value: "none" },
                { label: "Rectangle à gauche", value: "left-rectangle" },
                { label: "Rectangle à droite", value: "right-rectangle" },
                { label: "Fond bleu", value: "blue" },
            ],
            value: "none",
        },
        {
            label: "Largeur du rectangle (en %)",
            key: "width",
            type: ContentsTypes.SLIDER,
            value: "60",
        },
        {
            label: "Hauteur du rectangle (en %)",
            key: "height",
            type: ContentsTypes.SLIDER,
            value: "80",
        },
        {
            key: "dynamicPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            label: "",
        },
    ],
};
